import { Product } from 'common/types/entities/api/product'
import { CurationExtensionType } from '../../constants/product/curationExtensionType'
import { StateKey } from 'common/utils/flipState'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export const initialProduct: Product = {
  id: null,
  channelServiceType: null,
  channelProductType: null,
  channelProductSupplyType: null,
  channelProductStatusType: null,
  channelProductDisplayStatusType: null,
  category: null,
  name: null,
  productUrl: null,
  mobileProductUrl: null,
  channel: null,
  regDate: null,
  modDate: null,
  manufactureDate: null,
  validDate: null,
  storeKeepExclusiveProduct: false,
  epInfo: {
    naverShoppingRegistration: false,
    enuriRegistration: false,
    danawaRegistration: false,
  },
  best: false,
  displayDate: null,
  materialContent: null,
  orderRequestUsable: false,
  channelProductImages: null,
  channelProductAttributes: [],
  productNo: null,
  salePrice: 0,
  stockQuantity: 0,
  saleType: null,
  excludeAdminDiscount: false,
  payExposure: false,
  productStatusType: null,
  statusType: null,
  authenticationType: null,
  productImages: null,
  naverShoppingSearchInfo: null,
  afterServiceInfo: null,
  originAreaInfo: null,
  seoInfo: null,
  optionUsable: false,
  supplementProductUsable: false,
  purchaseReviewInfo: null,
  taxType: null,
  certification: false,
  certificationTargetExcludeContent: null,
  minorPurchasable: false,
  productInfoProvidedNoticeView: null,
  productAttributes: null,
  productDeliveryInfo: null,
  claimDeliveryInfo: null,
  benefitsView: null,
  benefitsPolicy: null,
  mobileBenefitsPolicy: null,
  saleAmount: null,
  reviewAmount: null,
  averageDeliveryLeadTime: null,
  sellerTags: null,
  bbsSeq: 0,

  galleryImages: null,
  materialImages: null,
  tagImages: null,
  barcodeImages: null,
  soldout: false,
  viewAttributes: null,
  detailAttributes: null,
  additionalAttributes: null,

  content: null,
  commentCount: 0,
  discounts: null,
  storeProducts: [],
  categoryProducts: [],
  relatedProducts: [],
  banner: null,
  hotdeal: null,
  ssChannel: null,
  windowProduct: null,
  interestFreePlans: { hasInterestFreePlans: false, adminBurden: {}, sellerBurden: {} },
  eCouponCategory: false,
  cultureCategory: false,
  mobileDiscountRatio: 0,
  channelProductNos: [],
  coordiProducts: [],

  purchasePoint: 0,
  totalPoint: 0,
  reviewPoint: 0,
  textReviewPoint: 0,
  photoVideoReviewPoint: 0,
  afterUseTextReviewPoint: 0,
  afterUsePhotoVideoReviewPoint: 0,
  managerReviewPoint: 0,
  storeMemberReviewPoint: 0,

  displayCategory: null,
  userNickname: null,
  extensionType: null,
  extensionKey: null,
  isCultureCostIncomeDeduction: false,
  proceedServiceCheck: {
    showServiceCheckGuide: false,
    startDay: undefined,
    startTime: undefined,
    endDay: undefined,
    endTime: undefined,
  },
  channelProductVideos: [],
  productVideos: [],
  productVideoAuth: null,
  todayDispatch: {
    thisDayDispatchYn: false,
    thisDayDispatchBasisTime: undefined,
    possibleDispatchDays: undefined,
    reasonAboutNoThisDayDispatch: undefined,
  },
  isPayRestrictCategory: false,
  isCustomProduct: false,
  isPointPlusMember: false,
}

const FETCH = 'product/FETCH'

export const fetchProduct = (
  curState: StateKey,
  id: string,
  extensionKey: string,
  extensionType: CurationExtensionType,
  headers?: any,
) => async dispatch => {
  let params = null
  if (extensionType && extensionKey) {
    params = {
      extensionType,
      extensionKey,
    }
  }

  const response = await axios.get<Product>(`/v1/products/${id}`, {
    params,
    ...getHeaders(headers),
  })

  const product: Product = response ? response.data : initialProduct
  dispatch({
    curState,
    product,
    type: FETCH,
  })
}

// reducers
const productReducer = (state = initialProduct, action) => {
  switch (action.type) {
    case FETCH:
      return action.product
    default:
      return state
  }
}

export default productReducer
